import { createAction, props } from '@ngrx/store';

import { MoneyInOutDetailResponse } from '../models/money-in-out-detail.model';
import { MoneyInOutListSearchCriteria } from '../models/money-in-out-list.model';

export const moneyInOutAction = {
  moneyInOutListRequest: createAction(
    '[Money In Out] money in out list request',
    props<{ payload: MoneyInOutListSearchCriteria }>()
  ),
  moneyInOutListResponse: createAction('[Money In Out] money in out list response', props<{ response: any }>()),
  viewMoneyInOutRequest: createAction('[Money In Out] money in out detail request', props<{ docNo: string }>()),
  viewMoneyInOutResponse: createAction(
    '[Money In Out] money in out detail response',
    props<{ response: MoneyInOutDetailResponse }>()
  )
};
